import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { objectValues } from 'src/app/shared/utils/global.utils';
import { TaskTypesSelectionSerializer } from './serializers/task-types-selection.serializer';
import { SearchStringSerializer } from './serializers/search-string.serializer';
import { ActiveTabSerializer } from './serializers/active-tab.serializer';
import {
  QueryParamSerializer,
  QueryParamsDto,
  QueryParamsKeys,
} from './model/sidebar-query-params.model';
import { SidebarTaskOwnershipSerializer } from './serializers/sidebar-task-ownership.serializer';

@Injectable({
  providedIn: 'root',
})
export class OriginalQueryParamsSerializerService {
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  private static readonly listOfSerializers: QueryParamSerializer<any>[] = [
    new TaskTypesSelectionSerializer(),
    new SidebarTaskOwnershipSerializer(),
    new ActiveTabSerializer(),
    new SearchStringSerializer(),
  ];

  deserializeQueryParamsIfAny(queryParams: Params): QueryParamsDto | null {
    const allRegisteredSidebarQueryParamsKeys = objectValues(QueryParamsKeys);
    const onlySidebarRelatedQueryParams: Params = {};

    for (const key of allRegisteredSidebarQueryParamsKeys) {
      if (!Object.hasOwn(queryParams, key)) {
        continue;
      }
      onlySidebarRelatedQueryParams[key] = queryParams[key];
    }

    if (objectValues(onlySidebarRelatedQueryParams).length === 0) {
      return null;
    }

    const result = {} as QueryParamsDto;

    for (const serializer of OriginalQueryParamsSerializerService.listOfSerializers) {
      if (serializer.keyIsIn(onlySidebarRelatedQueryParams)) {
        result[serializer.key] = serializer.deserializeQueryParamValue(
          onlySidebarRelatedQueryParams[serializer.key]
          // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        ) as any;
      } else {
        console.warn(
          'There is a registered sidebar query param but no converter is present'
        );
      }
    }

    return result;
  }

  serializeQueryParams(queryParams: QueryParamsDto): Params {
    const result: Params = {};
    for (const serializer of OriginalQueryParamsSerializerService.listOfSerializers) {
      if (serializer.keyIsIn(queryParams)) {
        result[serializer.key] = serializer.serializeToQueryParamValue(
          // eslint-disable-next-line  @typescript-eslint/no-explicit-any
          queryParams[serializer.key] as any
        );
      }
    }
    return result;
  }
}
